import { API_HOST, getHttpGetOptions } from '../../utils/api-util';

const getEndpoint = () => `${API_HOST}/currency-code`;

export const getViewAllCurrencyCodesRequest = () => [getEndpoint(), getHttpGetOptions()];
